import { render, staticRenderFns } from "./PhotowallResize.vue?vue&type=template&id=8b731e3c&"
import script from "./PhotowallResize.vue?vue&type=script&lang=js&"
export * from "./PhotowallResize.vue?vue&type=script&lang=js&"
import style0 from "./PhotowallResize.vue?vue&type=style&index=0&id=8b731e3c&prod&lang=scss&"
import style1 from "./PhotowallResize.vue?vue&type=style&index=1&id=8b731e3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports